import "../../styles/legacy-css/navStyles.css";
import React, { useEffect } from "react";
import { useMatch, useResolvedPath } from "react-router-dom";
import { useAccountContext } from "../../contexts/Account";
import { useScrollListener } from "../../hooks/index";
import {
  itemDataFromDynamo,
  useUserDataContext,
} from "../../contexts/UserDataContext";
import { calculateParentPath } from "../../utils/CalculateItems";
import { AddItemButton } from "../../styles/components/Buttons.styled";
import { LocationPath } from "../../styles/components/Header2.styled";
import { LocationPathItem } from "../../styles/components/Header.styled";
import {
  StyledHeaderLoggedIn,
  StyledHeaderNav,
  StyledHeaderNavCustomLink,
  StyledHeaderNavLoc,
  StyledHeaderNavUL,
  StyledNavLinks,
} from "../../styles/components/HeaderNav.styled";
import { StyledSearchArrowRight } from "../../styles/components/Search.styled";
import { UNTITLED } from "../../utils/Constants";
import { SearchBox } from "./Header/SearchBox";

type navBarLink = {
  to: string;
  label: string;
};

export function HeaderNav() {
  const {
    curParent,
    itemMap,
    setCurItemData,
    setParentToBe,
    setupgradedItemFormOpen,
    searchActive,
    itemSearchInput,
    recalculateCurrentArray,
    parentMap,
    displayNav,
    locationSearchInput,
    searchItemsInUse,
    displayNavLinks,
    subscriptionExpired,
  } = useUserDataContext();

  // Set up scroll listener for nav show/hide behavior
  useScrollListener();

  function addItem() {
    console.log("ADDING ITEM");
    setCurItemData({});
    setParentToBe(curParent);
    setupgradedItemFormOpen(true);
  }

  function editItem(item: itemDataFromDynamo) {
    setParentToBe(item.ParentId);
    setCurItemData(item);
    setupgradedItemFormOpen(true);
  }

  return (
    <StyledHeaderNav displaynav={displayNav.toString()} className="nav">
      {localStorage.getItem("CognitoIdToken") && (
        <StyledHeaderLoggedIn>
          <StyledHeaderNavLoc>
            {searchActive && (
              <div>
                Results for{" "}
                {locationSearchInput != ""
                  ? "Location Search: '" + locationSearchInput + "'"
                  : ""}{" "}
                {locationSearchInput != "" && itemSearchInput != ""
                  ? " and "
                  : ""}{" "}
                {itemSearchInput != ""
                  ? "Item Search: '" + itemSearchInput + "'"
                  : ""}
                {searchItemsInUse &&
                  'items currently in use in "' +
                    (itemMap[curParent]?.Name ?? "MASTER") +
                    '"'}
              </div>
            )}
            {!subscriptionExpired && (
              <>
                {curParent && !searchActive && (
                  <LocationPath key={"locationPath"}>
                    Location Path -{" "}
                    {curParent == "MASTER" && (
                      <LocationPathItem key="MASTER">MASTER</LocationPathItem>
                    )}
                    {curParent != "MASTER" &&
                      calculateParentPath(itemMap, curParent).map(
                        (s, index) => (
                          <React.Fragment key={s}>
                            {s == curParent && (
                              <LocationPathItem
                                onClick={() => editItem(itemMap[s])}
                              >
                                <strong>
                                  {s != "MASTER"
                                    ? itemMap[s].Name != null &&
                                      itemMap[s].Name?.trim() != ""
                                      ? " / " + itemMap[s].Name
                                      : " / " + UNTITLED
                                    : "MASTER"}
                                </strong>
                              </LocationPathItem>
                            )}
                            {(s == "MASTER" || s != curParent) && (
                              <LocationPathItem
                                onClick={() =>
                                  recalculateCurrentArray(parentMap, s, itemMap)
                                }
                              >
                                {s != "MASTER"
                                  ? itemMap[s].Name != null &&
                                    itemMap[s].Name?.trim() != ""
                                    ? " / " + itemMap[s].Name
                                    : " / " + UNTITLED
                                  : "MASTER"}
                              </LocationPathItem>
                            )}
                          </React.Fragment>
                        )
                      )}{" "}
                    <StyledSearchArrowRight />
                    <AddItemButton onClick={() => addItem()}>
                      Add Item
                    </AddItemButton>
                  </LocationPath>
                )}
              </>
            )}
            {subscriptionExpired && <div>Your subscription has expired!</div>}
          </StyledHeaderNavLoc>
          <SearchBox />
          <StyledNavLinks displaynavlinks={displayNavLinks.toString()}>
            <StyledHeaderNavUL>
              <CustomLink to="/Home" label="Home" />
              <CustomLink to="/FAQ" label="Guide" />
              <CustomLink to="/Rhett.Guyer" label="Services" />
              <CustomLink to="/MyItems" label="My Items" />
              <CustomLink to="/Lists" label="Lists" />
              {/* <CustomLink to="/Blog" label="Blog" /> */}
            </StyledHeaderNavUL>
          </StyledNavLinks>
        </StyledHeaderLoggedIn>
      )}
      {localStorage.getItem("CognitoIdToken") == null && (
        <>
          <StyledHeaderNavLoc>
            You are not logged in. Please login or register a new account.
          </StyledHeaderNavLoc>
          <StyledNavLinks displaynavlinks={displayNavLinks.toString()}>
            <StyledHeaderNavUL>
              <CustomLink to="/Home" label="Home" />
              <CustomLink to="/FAQ" label="Guide" />
              <CustomLink to="/Rhett.Guyer" label="Services" />
              <CustomLink to="/MyItems" label="My Items" />
              <CustomLink to="/Lists" label="Lists" />
              {/* <CustomLink to="/Blog" label="Blog" /> */}
            </StyledHeaderNavUL>
          </StyledNavLinks>
        </>
      )}
    </StyledHeaderNav>
  );
}

function CustomLink({ to, label }: navBarLink) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });
  return (
    <li className={isActive ? "active" : ""}>
      <StyledHeaderNavCustomLink to={to}>{label}</StyledHeaderNavCustomLink>
    </li>
  );
}
